import moment from 'moment'

moment.defaultFormat = ''

export default moment